import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { DashboardContext } from '../dashboard-context'
import errorIcon from '../../../images/iconNotification.png'
import successIcon from '../../../images/iconNotificationSuccess.png'
import styled from 'styled-components';

const SnackIcon = styled.img`
  width: 38px;
  height: 38px;
  margin-right: 12px;
  display: block;
`;

const Message = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 16px;
  color: #333;
`;

const useStyles = makeStyles(theme => ({
  success: {
    background: '#FFFFFF',
    borderRadius: '100px',
    fontFamily: 'DM Sans, sans-serif',
    fontSize: '16px',
    fontWeight: 500,
    padding: '0 12px',
  },
  error: {
    background: '#FFFFFF',
    borderRadius: '100px',
    fontFamily: 'DM Sans, sans-serif',
    fontSize: '16px',
    fontWeight: 500,
    padding: '0 12px',
  },
  icon: {
    color: '#333',
  },
  close: {
    padding: theme.spacing(0.5),
  },
}));

const Dashboard = (props) => {
  const { snackbar, closeSnackbar } = React.useContext(DashboardContext);
  const classes = useStyles();

  return (
    <React.Fragment>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={snackbar.show}
        autoHideDuration={snackbar.error ? 5000 : 3000}
        onClose={() => closeSnackbar(false)}
      >
        <SnackbarContent
          classes={{ root: (snackbar.error) ? classes.error : classes.success }}
          message={
            <Message>
              <SnackIcon src={snackbar.error ? errorIcon : successIcon} alt="icon" />
              <p>{snackbar.message}</p>
            </Message>
          }
          action={[
            <IconButton key="close" aria-label="close" color="inherit" onClick={() => closeSnackbar(false)}>
              <CloseIcon className={classes.icon} />
            </IconButton>
          ]}
        />
      </Snackbar>
    </React.Fragment> 
  )
}

export default Dashboard